import React from 'react'

export const ProfileIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="18"
            viewBox="0 0 16 18"
            fill="none"
        >
            <path
                d="M1.33398 16.355C1.33398 14.0538 4.31875 12.1883 8.00065 12.1883C11.6825 12.1883 14.6673 14.0538 14.6673 16.355M12.1673 5.52165C12.1673 7.82283 10.3018 9.68831 8.00065 9.68831C5.69946 9.68831 3.83398 7.82283 3.83398 5.52165C3.83398 3.22046 5.69946 1.35498 8.00065 1.35498C10.3018 1.35498 12.1673 3.22046 12.1673 5.52165Z"
                stroke="#040404"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
